import { Quote, Star } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const AVATAR_BG = ["bg-[#0891b2]", "bg-[#ef4444]", "bg-[#334155]"];

export function TestimonialsSection() {
  const { t } = useLang();

  return (
    <section className="py-20 bg-slate-50 relative" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-block text-[10px] tracking-[0.3em] text-[#ef4444] font-semibold mb-3 uppercase">
            {t.testimonials.eyebrow}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0891b2] mb-3 leading-tight">
            {t.testimonials.title}
          </h2>
          <p className="text-slate-600 leading-relaxed">{t.testimonials.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {t.testimonials.items.map((it, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-white rounded-2xl border border-slate-200 p-7 hover:shadow-xl transition-shadow"
            >
              <Quote className="absolute top-5 end-5 w-9 h-9 text-[#0891b2]/10" />
              <div className="flex items-center gap-1 mb-4">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="w-3.5 h-3.5 fill-[#ef4444] text-[#ef4444]" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed text-[15px] mb-6 min-h-[110px]">
                &ldquo;{it.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className={`w-11 h-11 rounded-full ${AVATAR_BG[i % 3]} text-white flex items-center justify-center font-display text-sm shrink-0`}>
                  {it.initials}
                </div>
                <div>
                  <div className="font-display text-sm text-[#0891b2]">{it.name}</div>
                  <div className="text-xs text-slate-500">{it.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap justify-center items-center gap-x-10 gap-y-3 text-slate-500 text-xs uppercase tracking-widest">
          <span className="flex items-center gap-2">
            <span className="font-display text-2xl text-[#0891b2] not-italic">500+</span> {t.testimonials.trust1}
          </span>
          <span className="hidden sm:block w-px h-6 bg-slate-300" />
          <span className="flex items-center gap-2">
            <span className="font-display text-2xl text-[#0891b2] not-italic">4.9</span> {t.testimonials.trust2}
          </span>
          <span className="hidden sm:block w-px h-6 bg-slate-300" />
          <span className="flex items-center gap-2">
            <span className="font-display text-2xl text-[#0891b2] not-italic">20+</span> {t.testimonials.trust3}
          </span>
        </div>
      </div>
    </section>
  );
}
